import React from "react";
import TwoColumnLayout from "../../layouts/TwoColumnLayout/TwoColumnLayout";

const KnowledgeBase = () => {
  return <TwoColumnLayout></TwoColumnLayout>;
};

export default KnowledgeBase;
